import NoteTypes = Boo.Objects.Enums.TaskNoteTypes;

export class TaskNoteTypes {
  static General = NoteTypes.General;
  static Reject = NoteTypes.Reject;
  static Accept = NoteTypes.Accept;
  static WorkblockResolution = NoteTypes.WorkblockResolution;
  static WorkblockReason = NoteTypes.WorkblockReason;
  static OnsiteImplementationNoteToReviewer = NoteTypes.OnsiteImplementationNoteToReviewer;
  static OnsiteImplementationRejectionNote = NoteTypes.OnsiteImplementationRejectionNote;
  static CustomerRejection = NoteTypes.CustomerRejection;
  static CsrRejection = NoteTypes.CsrRejection;
  static ContentFeedback = NoteTypes.ContentFeedback;
  static ImplementationFeedback = NoteTypes.ImplementationFeedback;
  static NoteForContentReviewer = NoteTypes.NoteForContentReviewer;
  static NoteForImplementationReviewer = NoteTypes.NoteForImplementationReviewer;
  static CustomerFeedback = NoteTypes.CustomerFeedback;
  static Unlock = NoteTypes.Unlock;
}